import { render, staticRenderFns } from "./KCountryFlags.vue?vue&type=template&id=2e36b70c&"
import script from "./KCountryFlags.vue?vue&type=script&lang=js&"
export * from "./KCountryFlags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports